import React, { useEffect, useState } from "react";
import "./LoginView.css";
import PricingGuideOverlay from "./pricing/PricingGuideOverlay";
import UserRegistrationOverlay from "./registration/UserRegistrationOverlay";

interface LoginViewProps {
    onLogin: () => void;
}

const BACKGROUND_IMAGES = [
    "/image/login1.webp",
    "/image/login2.webp",
    "/image/login3.webp",
    "/image/login4.png",
    "/image/login5.png",
];

export default function LoginView({ onLogin }: LoginViewProps) {
    const [showPricing, setShowPricing] = useState(false);
    const [showRegistration, setShowRegistration] = useState(false);
    const [bgIndex, setBgIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setBgIndex((prev) => (prev + 1) % BACKGROUND_IMAGES.length);
        }, 4000);
        return () => clearInterval(interval);
    }, []);

    const handleLogin = (e: React.FormEvent) => {
        e.preventDefault();
        onLogin();
    };

    return (
        <div className="login-page-container">
            <div className="login-bg-slideshow">
                {BACKGROUND_IMAGES.map((src, index) => (
                    <div
                        key={src}
                        className={`login-bg-slide${index === bgIndex ? " active" : ""}`}
                        style={{ backgroundImage: `url(${src})` }}
                    />
                ))}
                <div className="login-bg-overlay"></div>
            </div>

            <div className="login-box">
                <div className="login-logo">
                    <img src="/image/EVIEW_wh.png" alt="EVIEW" className="logo-image" />
                </div>

                <form className="login-form" onSubmit={handleLogin}>
                    <div className="input-group">
                        <input type="text" placeholder="이메일 계정" className="login-input" />
                    </div>

                    <div className="input-group password-group">
                        <input type="password" placeholder="비밀번호" className="login-input" />
                    </div>

                    <button type="submit" className="login-submit-btn">로그인</button>

                    <div className="login-links">
                        <button type="button" className="text-link" onClick={() => setShowRegistration(true)}>사용자 등록</button>
                        <span className="divider">|</span>
                        <button type="button" className="text-link">비밀번호 찾기</button>
                        <span className="divider">|</span>
                        <button type="button" className="text-link highlight-link" onClick={() => setShowPricing(true)}>요금제 및 기업 등록</button>
                    </div>
                </form>
            </div>

            <div className="login-side-content">
                <h1 className="side-title">운전부터 정비까지, 한 곳에서</h1>
                <h2 className="side-subtitle">스마트한 당신의 차량관리 시스템</h2>
            </div>

            {showPricing && (
                <PricingGuideOverlay onClose={() => setShowPricing(false)} />
            )}

            {showRegistration && (
                <UserRegistrationOverlay 
                    onClose={() => setShowRegistration(false)} 
                    onSuccess={() => setShowRegistration(false)} 
                />
            )}
        </div>
    );
}
